import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import http from 'axios'

import { withStyles } from '@mui/styles'
import { style } from 'styles'
import Products from './components/Products'

function OffersList({ classes }) {
	const dispatch = useDispatch()
	const { categoriesArray, products } = useSelector(state => state.products)

	useEffect(() => {
		const loadProducts = async() => {
			const products = await http.get(`${window.__endpoint}/api/products/offers`)
			dispatch({ type: 'loadProducts@products', products: products })
		}

		// Se cambia la categoria selezionata o al completamento del load delle categorie eseguo il caricamento dei prodotti
		dispatch({ type: 'loadProducts@products', products: null })
		loadProducts()
	}, [categoriesArray])

	return (<div className={classes.page}>
		{categoriesArray.length > 0 && <div>
			<h3 className={classes.pageTitle}>Offerte</h3>
			<Products
				products={products}
				noProduct="Al momento non è disponibile nessun prodotto in offerta"
			/>
		</div>}
	</div>)
}

export default withStyles(style)(OffersList)
